/** Count File / Blob entries across one or more upload field values. */
export function countUploadFiles(...fields) {
  return fields.reduce((total, field) => {
    if (!field) return total;
    if (Array.isArray(field)) {
      return total + field.filter((item) => item instanceof Blob || item?.name).length;
    }
    if (typeof FileList !== "undefined" && field instanceof FileList) {
      return total + Array.from(field).filter(Boolean).length;
    }
    if (field instanceof Blob || field?.name) return total + 1;
    return total;
  }, 0);
}

export const IDLE_SAVE_PROGRESS = {
  phase: "idle",
  percent: null,
  current: 0,
  total: 0,
};

/**
 * Build axios `onUploadProgress` that reports upload % and estimated file count.
 * When bytes finish uploading, phase becomes `processing` while the server responds.
 */
export function createUploadProgressHandler({
  fileCount = 0,
  onProgress,
} = {}) {
  const totalFiles = Math.max(0, Number(fileCount) || 0);

  return (event) => {
    if (typeof onProgress !== "function") return;

    const loaded = Number(event?.loaded) || 0;
    const total = Number(event?.total) || 0;

    if (total > 0) {
      const percent = Math.min(100, Math.round((loaded / total) * 100));
      const current =
        totalFiles > 0
          ? Math.min(
              totalFiles,
              Math.max(percent >= 100 ? totalFiles : 1, Math.round((loaded / total) * totalFiles)),
            )
          : 0;

      onProgress({
        phase: percent >= 100 ? "processing" : "uploading",
        percent,
        current,
        total: totalFiles,
      });
      return;
    }

    onProgress({
      phase: "uploading",
      percent: null,
      current: 0,
      total: totalFiles,
    });
  };
}
